import { _ } from 'vue-underscore';
import responsive from './responsive';

export default {
  mixins: [responsive],
  data() {
    return {
      resultsContentTop: 0,
      currentScrollTop: 0,
      footer: null,
      footerObserver: IntersectionObserver,
      isFooterInView: false,
      fullNavHeight: 0,
      // IMPORTANT - CHANGE ONLY IF ACTUAL VALUES CHANGE
      // pre- known fixed heights in pixels - hard coded rather than dynamic to avoid page reflow since not necessary as these are always constant for now
      // Desktop nav height 71px plus navbar drawers 40px
      navbarHeight: 111,
      smallNavbarHeight: 49,
      // technically 56px but the Filter-mobile__filters isnt taking the topbar into consideration
      mobileNavbarHeight: 66,
      breadcrumbHeight: 33,
      heroHeight: 0,
    };
  },
  computed: {
    resultsAll() {
      return this.$store.getters['results/getAvailableProperties'];
    },
  },
  methods: {
    observeFooter() {
      this.footer = document.querySelector('.footer');
      this.footerObserver = new IntersectionObserver(this.onObserveItem);
      this.footerObserver.observe(this.footer);
    },
    onObserveItem(entries) {
      this.isFooterInView = false;
      for (const entry of entries) {
        if (entry.isIntersecting) {
          // console.log('footer entry intersecting', entry)
          this.isFooterInView = true;
          this.$store.commit('filterbar/setFooterInView', true);
          const numberOfResults = this.resultsAll.length;

          if (document.getElementById('results-content')) {
            const results_content = document.getElementById('results-content') ? document.getElementById('results-content').getBoundingClientRect() : null;
            const results_header = document.getElementById('results-header') ? document.getElementById('results-header').getBoundingClientRect() : null;
            this.resultsContentTop = results_content.height - (window.innerHeight - results_header.height);
            // console.log('results_header', results_header);
            // console.log('results_content', results_content);

            if (results_content.width == 0) {
              const map_content = document.getElementById('results-map-area') ? document.getElementById('results-map-area').getBoundingClientRect() : null;
              this.resultsContentTop = map_content.height - (window.innerHeight - 150);
            }

            this.$store.commit('results/setResultsContentTop', Math.round(this.resultsContentTop));
            // console.log('this.resultsContentTop', Math.round(this.resultsContentTop));
          }
        } else {
          this.isFooterInView = false;
          this.$store.commit('filterbar/setFooterInView', false);
          // console.log('footer entry NOT intersecting', entry)
        }
      }
    },

    checkifNavBarFixed() {
      const buffer = 20;
      this.fullNavHeight = !this.isMobile
        ? this.navbarHeight
        : this.mobileNavbarHeight;

      if (this.currentScrollTop >= (this.fullNavHeight - buffer)) {
        this.$store.commit('common/setNavfixed', true);
        this.fullNavHeight = this.smallNavbarHeight;
      } else {
        this.$store.commit('common/setNavfixed', false);
      }

      this.$store.commit('common/setFullNavHeight', this.fullNavHeight);
    },
    fixedFilterbar() {
      this.heroHeight = document.querySelector('.results-hero-header') ? document.querySelector('.results-hero-header').offsetHeight : 0;
      const maxPosition = this.navbarHeight + this.heroHeight + this.breadcrumbHeight;

      if ((this.currentScrollTop >= maxPosition) && this.isDesktop) {
        this.$store.commit('filterbar/setFilterbarfixed', true);
      } else {
        this.$store.commit('filterbar/setFilterbarfixed', false);
      }
    },
    calculateSticky() {
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.$store.commit('common/setCurrentScrollTop', this.currentScrollTop);

      this.checkifNavBarFixed();
      this.isDesktop ? this.fixedFilterbar() : null;
    },
    handleResize: _.throttle(function () {
      this.calculateSticky();
    }, 200),
    handleScroll: _.throttle(function () {
      this.calculateSticky();
    }, 200),
  },
  mounted() {
    window.addEventListener('resize', this.handleResize, { passive: true });
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.observeFooter();
    this.calculateSticky();
    setTimeout(() => this.calculateSticky(), 5000);
  },
  beforeDestroy() {
    this.footerObserver.unobserve(this.footer);
    this.footerObserver.disconnect();
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
};
